var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNumberIcon8(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 76.069,
    height: 92.868,
    viewBox: "0 0 76.069 92.868",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Path_32396",
    x: 0,
    y: 0,
    width: 76.069,
    height: 92.868,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 0, 0)",
    filter: "url(#Path_32396)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32396-2",
    "data-name": "Path 32396",
    d: "M-21.192-56.429A22.583,22.583,0,0,1-11.6-63.584,36.856,36.856,0,0,1,2.762-66.176a37.058,37.058,0,0,1,14.517,2.592,22.066,22.066,0,0,1,9.488,7.207,17.55,17.55,0,0,1,3.37,10.629,16.893,16.893,0,0,1-2.8,9.592,20.312,20.312,0,0,1-7.881,6.792,22.127,22.127,0,0,1,9.073,6.74A16.351,16.351,0,0,1,31.8-12.358,17.939,17.939,0,0,1,28.271-1.314,22.9,22.9,0,0,1,18.212,6.048,41.063,41.063,0,0,1,2.762,8.692,41.063,41.063,0,0,1-12.689,6.048,22.9,22.9,0,0,1-22.747-1.314a17.939,17.939,0,0,1-3.526-11.044,16.529,16.529,0,0,1,3.215-10.266,21.722,21.722,0,0,1,9.022-6.74,19.9,19.9,0,0,1-7.829-6.792,17.125,17.125,0,0,1-2.748-9.592A17.307,17.307,0,0,1-21.192-56.429ZM19.457-12.876A9.609,9.609,0,0,0,15-21.224q-4.459-3.059-12.236-3.059T-9.474-21.224a9.609,9.609,0,0,0-4.459,8.347A9.609,9.609,0,0,0-9.474-4.529Q-5.015-1.47,2.762-1.47T15-4.529A9.609,9.609,0,0,0,19.457-12.876ZM18.109-45.229a9.719,9.719,0,0,0-4.148-8.244q-4.148-3.059-11.2-3.059-6.948,0-11.147,3.059a9.681,9.681,0,0,0-4.2,8.244,9.417,9.417,0,0,0,4.2,8.14q4.2,2.955,11.147,2.955,7.051,0,11.2-3.007A9.489,9.489,0,0,0,18.109-45.229Z",
    transform: "translate(35.27 72.18)",
    fill: "#fcbf49"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNumberIcon8);
export default __webpack_public_path__ + "static/media/number-icon8.96867076726f8b5e2537b5d606211687.svg";
export { ForwardRef as ReactComponent };